// Equity the book would need, closest to close first.
//
// Cumulative rather than weighted: "diligence alone needs $5.5M, through LOI
// $34.8M" is a statement anyone can check, where a probability-weighted figure
// would rest on close rates nobody has agreed. Deliberately says nothing about
// the fund — no target, no committed capital — so it can sit in front of
// investors without implying either.
import { stageRamp } from "../common/brand";
import { STAGE_LABEL } from "../../services/homeView";

const M = (v) => `$${(v / 1e6).toFixed(1)}M`;
const THROUGH = { "In Diligence": "Diligence only", "LOI Submitted": "Through LOI", "Underwriting": "Through underwriting" };

export default function EquityByStage({ ladder, equityPct, bind }) {
  const total = ladder.length ? ladder[ladder.length - 1].cumulative : 0;
  return (
    <section data-print-block className="rounded-[14px] border border-[#3a3a3a] bg-[#242424] px-6 py-5">
      <div className="text-[10.5px] font-semibold uppercase tracking-[0.14em] text-[#8a8a8a]">Equity the book would need</div>
      <div className="mt-1 text-[12px] text-[#8a8a8a]">Cumulative, closest to close first · {Math.round(equityPct * 100)}% equity</div>

      {total > 0 && (
        <div className="mt-6 flex h-3 gap-[2px]">
          {ladder.filter((l) => l.equity > 0).map((l, i, arr) => (
            <div key={l.stage}
              {...bind(<><div className="text-[10.5px] text-[#8a8a8a]">{STAGE_LABEL[l.stage]}</div>{M(l.equity)} of equity · {M(l.cumulative)} cumulative</>)}
              className={`${i === 0 ? "rounded-l" : ""} ${i === arr.length - 1 ? "rounded-r" : ""}`}
              style={{ width: `${(l.equity / total) * 100}%`, background: stageRamp[l.stage] }} />
          ))}
        </div>
      )}

      <div className="mt-4 grid gap-2.5">
        {ladder.map((l) => (
          <div key={l.stage} className="flex justify-between text-[12.5px]">
            <span className="flex items-center gap-2 text-[#b4b4b4]">
              <span className="inline-block h-[9px] w-[9px] rounded-[2px]" style={{ background: stageRamp[l.stage] }} />
              {THROUGH[l.stage]}
            </span>
            <span className="font-semibold text-[#f4f4f4]">{M(l.cumulative)}</span>
          </div>
        ))}
      </div>

      <p className="mt-4 text-[10.5px] leading-relaxed text-[#7a7a7a]">
        Assumes {Math.round(equityPct * 100)}% equity against book value. Book value is our underwritten price where we have one, otherwise the ask.
      </p>
    </section>
  );
}
